/**
 * Token da sessão do membro vai no FRAGMENTO da URL, não na query.
 *
 * `?access_token=<jwt>` viajava inteiro para os access logs do nginx/ALB, para
 * o upstream do Amplify, para o GA4 e para os pixels do lojista — todos
 * recebem a URL completa. O fragmento (`#…`) nunca sai do navegador: não vai
 * na requisição nem no `Referer`. O front-member lê o fragmento primeiro e
 * cai para a query por compatibilidade (curseduca-front-member #2694).
 *
 * Os outros parâmetros (`receipt=` etc.) continuam na query.
 */
export const SESSION_FRAGMENT_KEY = 'access_token';

/**
 * `url` + `#access_token=<token>`. Sem token, devolve a URL como está; URL que
 * já tem fragmento também fica como está (não há como ter dois).
 */
export const withSessionFragment = (
	url: string,
	token?: string | null
): string => {
	if (!token) return url;
	if (url.includes('#')) return url;
	return `${url}#${SESSION_FRAGMENT_KEY}=${encodeURIComponent(token)}`;
};
